import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=796ad9d9&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormText, BCol, BFormInput, BButton, BInputGroupAppend, BInputGroup, BRow, BForm} from 'bootstrap-vue'
    installComponents(component, {BFormText, BCol, BFormInput, BButton, BInputGroupAppend, BInputGroup, BRow, BForm})
    

export default component.exports